// ###### IMPORTS
import React from 'react';
import CardHierarchicalCategories from './viewComponents/CardHierarchicalCategories';
import CardFinanceProfile from './viewComponents/CardFinanceProfile';
import CardUserCurrencies from './viewComponents/CardUserCurrencies';

// ###### MAIN COMPONENT
const TabFinanceSettings = () => {
  return (
    <div className="p-0 flex flex-col gap-2 w-full mt-2">
      <CardFinanceProfile />
      <CardUserCurrencies />
      <CardHierarchicalCategories />
    </div>
  );
};

export default TabFinanceSettings;
